import type { ContractorUser, HomeownerUser } from "@/hooks/queries/useMe";
import { getUserComplements } from "@/hooks/complements/get-user-complements";
import ContractorMobileDrawerContent from "./ContractorMobileDrawerContent";
import HomeownerMobileDrawerContent from "./HomeownerMobileDrawerContent";

export default function LoggedInMobileDrawerContent({
  user,
  onClose,
}: LoggedInMobileDrawerContentProps) {
  const { isHomeowner, isContractor } = getUserComplements(user);

  if (isContractor) {
    return <ContractorMobileDrawerContent user={user as ContractorUser} onClose={onClose} />;
  } else if (isHomeowner) {
    return <HomeownerMobileDrawerContent user={user as HomeownerUser} onClose={onClose} />;
  } return null;
}

interface LoggedInMobileDrawerContentProps {
  user: HomeownerUser | ContractorUser;
  onClose: () => void;
}
